import { ContractResponseModel } from "@gtpl/shared-models/hrms";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { ContractorDto } from "./dto/human-resource-agent.dto";
import { ContractRequest } from "./dto/human-resource-agent.request";
import { ContractorService } from "./human-resource-agent.service";

@ApiTags('contractor')
@Controller('contractor')
export class ContractorController {
    constructor(
        private service: ContractorService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    @Post('/createContractor')
    async createContractor(@Body() DTO: ContractorDto, isUpdate: boolean = false): Promise<ContractResponseModel>{
        try{
            return await this.service.createContractor(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContractResponseModel, error);
        }
    }

    @Post('/updateContractor')
    async updateContractor(@Body() DTO: ContractorDto, isUpdate: boolean = false): Promise<ContractResponseModel>{
        try{
            return await this.service.createContractor(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContractResponseModel, error);
        }
    }

    @Post('/getAllContractorActions')
    async getAllContractorActions(): Promise<ContractResponseModel>{
        try{
            return await this.service.getAllContractorActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContractResponseModel, error);
        }
    }

    @Post('/getAllActiveContractActions')
    async getAllActiveContractActions(): Promise<ContractResponseModel>{
        try{
            return await this.service.getAllActiveContractActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContractResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateContractor')
    async activateOrDeactivateContractor(@Body() conReq: ContractRequest): Promise<ContractResponseModel>{
        try{
            return await this.service.activateOrDeactivateContractor(conReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContractResponseModel, error);
        }
    }
}